import React from "react";
import { Button } from "design-system/components/button/button";
import { ButtonSize } from "design-system/components/button/button.types";
import illustration from "public/assets-v2/illustrations/complete.svg";
import {
  FinishCard,
  ContentContainer,
  ButtonContainer,
  Illustration,
  Title,
  Description,
  PointsCard,
  PointsRow,
  DetailLabel,
  DetailValue,
  Divider,
  TotalPoints
} from "./practice-finished.styles";

export interface PracticeFinishedProps {
  totalPoints?: number;
  correctPoints?: number;
  effortPoints?: number;
  onViewRanking: () => void;
}

export const PracticeFinished: React.FC<PracticeFinishedProps> = ({
  totalPoints = 0,
  correctPoints = 0,
  effortPoints = 0,
  onViewRanking
}) => (
  <FinishCard>
    <ContentContainer>
      <Illustration src={illustration} alt="Latihan selesai" />
      <Title>Hore! Latihan selesai!</Title>
      <Description>
        Kamu mendapat <strong>+{totalPoints} poin</strong>
      </Description>
      <PointsCard>
        <PointsRow>
          <TotalPoints>Total:</TotalPoints>
          <TotalPoints>+{totalPoints} Poin</TotalPoints>
        </PointsRow>
        <Divider />
        <PointsRow>
          <DetailLabel>Jawaban benar</DetailLabel>
          <DetailValue>{correctPoints} Poin</DetailValue>
        </PointsRow>
        <PointsRow>
          <DetailLabel>Usahamu</DetailLabel>
          <DetailValue>{effortPoints} Poin</DetailValue>
        </PointsRow>
      </PointsCard>
    </ContentContainer>

    <ButtonContainer>
      <Button
        appearance="general"
        variant="primary"
        size={ButtonSize.lg}
        isFullWidth
        onClick={onViewRanking}
      >
        Lihat peringkatku
      </Button>
    </ButtonContainer>
  </FinishCard>
);
